import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './Products.css';

const Products = ({ showAll = false, onViewAll }) => {
  const [products, setProducts] = useState([]);
  const whatsappNumber = '905384125126';

  useEffect(() => {
    const productsRef = ref(database, 'products');
    const unsubscribe = onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const productsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setProducts(productsList);
      } else {
        setProducts([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleWhatsAppClick = (productTitle) => {
    const message = `Merhaba, ${productTitle} için teklif almak istiyorum.`;
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const displayProducts = showAll ? products : products.slice(0, 3);

  return (
    <section id="products" className="products">
      <div className="container">
        {!showAll && (
          <div className="section-header">
            <h2 className="section-title">Ürünlerimiz</h2>
            <p className="section-subtitle">
              Bulut Ambalaj olarak çeşitli boyut ve tasarım seçenekleriyle karton bardak üretimi yapıyoruz.
            </p>
          </div>
        )}
        {products.length === 0 ? (
          <div className="products-empty">
            <p>Henüz ürün eklenmemiş.</p>
          </div>
        ) : (
          <>
            <div className="products-grid">
              {displayProducts.map((product, index) => (
                <div key={product.id || index} className="product-item">
                  {product.image && (
                    <img src={product.image} alt={product.title} className="product-image" />
                  )}
                  <h3>{product.title}</h3>
                  <p>{product.description}</p>
                  <button
                    onClick={() => handleWhatsAppClick(product.title)}
                    className="offer-btn"
                  >
                    Teklif Al
                  </button>
                </div>
              ))}
            </div>
            {!showAll && products.length > 3 && (
              <div className="view-all-container">
                <button onClick={onViewAll} className="view-all-btn">
                  Ürünlerin Hepsini Görüntüle
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Products;
